import { Colors } from "../../../../styles/theme";

const boxBorder = "1px solid #D7E1EF";
const boxRadius = "8px";

const styles = {
  eyebrow: {
    fontWeight: 800,
    letterSpacing: 3,
    textAlign: "center",
    textTransform: "uppercase",
  },
  heading: {
    color: Colors.navy,
    fontSize: { xs: "2.35rem", md: "4rem" },
    fontWeight: 800,
    letterSpacing: 0,
    lineHeight: 1.08,
    textAlign: "center",
  },
  description: {
    fontWeight: 500,
    lineHeight: 1.65,
    textAlign: "center",
  },
  explorer: {
    width: "100%",
    maxWidth: "none",
    boxSizing: "border-box",
    mt: { xs: 4, md: 6 },
    px: { xs: 1, sm: 3, md: 5 },
    "@media (max-width:600px) and (max-height:750px)": {
      px: 0,
    },
  },
  tabs: {
    display: "flex",
    gap: { xs: 1, md: 1.5 },
    overflowX: "auto",
    pb: 0.5,
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tab: {
    flex: "0 0 auto",
    minHeight: { xs: 48, md: 54 },
    px: { xs: 2, md: 3 },
    border: "1px solid #C9D6E8",
    borderRadius: "999px",
    backgroundColor: Colors.white,
    color: "#324861",
    fontSize: { xs: "0.88rem", md: "1rem" },
    fontWeight: 800,
    lineHeight: 1.2,
    whiteSpace: "nowrap",
    transition: "background-color 160ms ease, color 160ms ease, border-color 160ms ease",
    "&:hover": {
      borderColor: Colors.primary,
    },
    "&:focus-visible": {
      outline: `3px solid ${Colors.blue}`,
      outlineOffset: "2px",
    },
  },
  tabActive: {
    borderColor: Colors.primary,
    backgroundColor: Colors.primary,
    color: Colors.white,
    boxShadow: "0 8px 20px rgba(47, 84, 150, 0.2)",
  },
  explorerBody: {
    display: "grid",
    gridTemplateColumns: {
      xs: "minmax(0, 1fr)",
      md: "280px minmax(0, 1fr)",
      lg: "320px minmax(0, 1fr)",
    },
    alignItems: "start",
    gap: { xs: 2, md: 2.5 },
    mt: { xs: 2.5, md: 3 },
  },
  featureNav: {
    minWidth: 0,
    display: "grid",
    gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", md: "1fr" },
    gap: 1.25,
    "@media (max-width:520px)": {
      gridTemplateColumns: "minmax(0, 1fr)",
    },
  },
  featureButton: {
    width: "100%",
    minWidth: 0,
    minHeight: { xs: 64, md: 72 },
    justifyContent: "flex-start",
    gap: 1.5,
    px: { xs: 1.5, md: 2 },
    py: 1,
    position: "relative",
    overflow: "hidden",
    border: boxBorder,
    borderRadius: boxRadius,
    backgroundColor: Colors.white,
    color: Colors.navy,
    textAlign: "start",
    transition: "border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease",
    "&:hover": {
      borderColor: "#8EA9CC",
      boxShadow: "0 8px 18px rgba(34, 49, 78, 0.07)",
    },
    "&:focus-visible": {
      outline: `3px solid ${Colors.blue}`,
      outlineOffset: "2px",
    },
  },
  featureButtonActive: {
    boxShadow: "0 8px 20px rgba(34, 49, 78, 0.08)",
    "&::before": {
      content: '""',
      position: "absolute",
      insetBlock: 0,
      insetInlineStart: 0,
      width: "5px",
      backgroundColor: Colors.primary,
    },
  },
  featureNumber: {
    flexShrink: 0,
    color: "#7893B6",
    fontSize: "0.78rem",
    fontWeight: 800,
  },
  featureButtonLabel: {
    minWidth: 0,
    flex: 1,
    color: Colors.navy,
    fontSize: { xs: "0.9rem", md: "1rem" },
    fontWeight: 800,
    lineHeight: 1.35,
    overflowWrap: "anywhere",
  },
  featureArrow: {
    flexShrink: 0,
    color: Colors.primary,
    fontSize: "1.15rem",
  },
  detailCard: {
    minWidth: 0,
    overflow: "hidden",
    border: boxBorder,
    borderRadius: boxRadius,
    backgroundColor: Colors.white,
  },
  imageStage: {
    width: "100%",
    minHeight: { xs: 240, sm: 320, lg: 420 },
    aspectRatio: { xs: "4 / 3", sm: "16 / 8" },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    p: 0,
    backgroundColor: "#E4ECF7",
  },
  productImage: {
    display: "block",
    width: "100%",
    height: "100%",
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
  },
  detailContent: {
    p: { xs: 2.5, sm: 4, md: 5 },
  },
  detailEyebrow: {
    color: Colors.primary,
    fontSize: "0.78rem",
    fontWeight: 800,
    letterSpacing: 2,
    textTransform: "uppercase",
  },
  detailTitle: {
    mt: 1.5,
    color: Colors.navy,
    fontSize: { xs: "1.8rem", md: "2.25rem" },
    fontWeight: 800,
    letterSpacing: 0,
    lineHeight: 1.15,
  },
  pointsList: {
    mt: 2,
    mb: 0,
    ps: { xs: 2.5, sm: 3 },
  },
  point: {
    mb: 1.25,
    fontSize: { xs: "0.95rem", md: "1.05rem" },
    fontWeight: 500,
    lineHeight: 1.6,
    "&:last-child": {
      mb: 0,
    },
  },
};

export default styles;
